import { makeObservable, observable, action, flow } from "mobx";
import { getAgentList, assignAgentToDocument } from "../../../services";
// TODO: Descomentar cuando deleteAgent esté listo
// import { getAgentList, assignAgentToDocument, deleteAgent } from "../../../services";

class AgentsStore {
  agents = [];
  isLoading = false;
  error = null;
  assignDocumentLoading = false;

  constructor() {
    makeObservable(this, {
      // Observables
      agents: observable,
      isLoading: observable,
      error: observable,
      assignDocumentLoading: observable,

      // Actions
      setAgents: action,
      setLoading: action,
      setError: action,
      setAssignDocumentLoading: action,
      // Flows (async actions)
      fetchAgents: flow,
      getAgentById: flow,
      createAgent: flow,
      deleteAgent: flow,
      assignDocumentAgent: flow
    });
  }

  // Actions
  setAgents = (agents) => {
    this.agents = agents;
  };

  setLoading = (status) => {
    this.isLoading = status;
  };

  setError = (error) => {
    this.error = error;
  };

  setAssignDocumentLoading = (status) => {
    this.assignDocumentLoading = status;
  };

  // API Actions
  *fetchAgents() {
   try {
            this.isLoading = true;
            this.error = null;
            
            const response = yield getAgentList();
            const { data } = response;
            
            // Solo necesitamos los agentes, el resto de información la manejamos en el error si es necesario
            this.setAgents(data?.agents || []);

        } catch (error) {
            console.error('Error in fetchAgentList:', error);
            this.error = error.response?.data?.msgCode?.[0]?.description || "Error fetching agents list";
            this.setAgents([]); // Limpiar la lista en caso de error
            throw error;
        } finally {
            this.isLoading = false;
        }
  }
  
  *assignDocumentAgent(body) {
    this.setAssignDocumentLoading(true);
    this.setError(null);
    try {
      const response = yield assignAgentToDocument(body);
      return response;
    } catch (error) {
      console.error('Error assigning document to agent:', error);
      this.setError(error);
      throw error;
    } finally {
      this.setAssignDocumentLoading(false);
    }
  }

  *getAgentById(id) {
    // TODO: Implement call to service
  }

  *createAgent(agentData) {
    // TODO: Implement call to service
  }

  *deleteAgent(id) {
    // TODO: Implementar cuando deleteAgent esté listo en el servicio
    // try {
    //   this.setLoading(true);
    //   this.setError(null);
    //   const response = yield deleteAgent(id);
    //   // Remover el agente de la lista local después de eliminarlo
    //   this.setAgents(this.agents.filter(agent => agent.uuid !== id && agent.id !== id));
    //   return response;
    // } catch (error) {
    //   console.error('Error deleting agent:', error);
    //   this.setError(error);
    //   throw error;
    // } finally {
    //   this.setLoading(false);
    // }
  }
}

export default AgentsStore;